<template>
  <div
    class="navbar-experimental app-navbar">
    <div class="container">
      <div class="logo el-row is-justify-center el-row--flex">
        <a
          v-if="showBack"
          class="navbar-experimental__back-btn"
          @click="backBtnHandler">
          <img
            class="img-fluid button"
            src="../../assets/images/back_button.svg"
            alt="Back Button">
        </a>
        <div class="navbar-experimental__logo">
          <router-link to="/">
            <NewLogo/>
          </router-link>
        </div>
        <div v-if="showStep" class="navbar-experimental__step">
          <span class="hidden-sm-and-down">Step {{ step }} of 3</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NewLogo from '../NewLogo';

export default {
  name: 'E1Navbar',
  components: { NewLogo },
  props: {
    step: {
      type: Number,
      default: () => 1,
    },
    showStep: {
      type: Boolean,
      default: true,
    },
    showBack: {
      type: Boolean,
      default: true,
    },
    swapMobileLogo: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    backBtnHandler() {
      this.$analyticsV2.logEvent('cf_back_button_clicked');
      this.$emit('back');
    },
  },
};
</script>

<style lang="scss" scoped>

@import "../../assets/scss/variables.scss";

.navbar-experimental {
  &__back-btn {
    cursor: pointer;
    flex: 1 1 100px;
  }
  &__logo {
    flex: 1 1 150px;
    text-align: center;
  }
  &__step {
    flex: 1 1 100px;
    text-align: right;
  }
}

.app-navbar {
  z-index: 998;
  height: 72px;
  min-height: 72px;
  padding: 6px 0;
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  background-color: $dark-background;
  color: $brand;
  .logo {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    img {
      width: 130px;
      height: 36px;
      @media (max-width: 567px) {
        width: 123px;
        height: 30px;
      }
    }
    .button {
      width: 50px;
      @media (max-width: 567px) {
        //width: 15px;
        //height: 30px;
        //margin-right: 15px;
      }
    }
  }
}

</style>
